"use client";

import { Bars3Icon } from "@heroicons/react/24/outline";
import { useState } from "react";
import Button from "./Button";

interface BarsMenuProps {
  children: React.ReactNode;
  className?: string;
  initiallyOpen?: boolean;
}

const BarsMenu = ({
  children,
  className = "",
  initiallyOpen = false,
}: BarsMenuProps) => {
  const [isOpen, setIsOpen] = useState(initiallyOpen);

  return (
    <div className={`${className}`}>
      <Button
        size="m"
        variant="tertiary"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Menu"
      >
        <Bars3Icon className="w-5 h-5" />
      </Button>
      <div
        className={`${
          isOpen ? "" : "hidden"
        } bg-white flex flex-col md:flex-row absolute left-0 right-0 items-start md:relative md:items-center px-3 md:px-0 top-full justify-end gap-2 text-sm font-normal whitespace-nowrap text-ellipsis w-full py-4 md:py-0`}
      >
        {children}
      </div>
    </div>
  );
};

export default BarsMenu;
